import produce from 'immer';
import { SET_CREDIT_REQUEST_BY_MY_WORKLIST } from './constants';

export const initialState = {
  creditRequests: [],
};

const reducer = (state = initialState, { type, payload }: any) =>
  produce(state, (draft: any) => {
    switch (type) {
      case SET_CREDIT_REQUEST_BY_MY_WORKLIST:
        draft.creditRequests = payload;
        break;

      default:
        break;
    }
  });

export default reducer;
